import styled from "styled-components";

export const Fieldset = styled.fieldset<{
  gap?: string;
}>`
  display: flex;
  flex-direction: column;
  gap: ${props => props.gap || "10px"};
`;